/** Tint + text classes for a status pill, keyed by pill variant. */
export var SMS_PILL_CLASSES = {
  viewed: "bg-sds-success-tertiary text-sds-success-default",
  delivered: "bg-sds-brand-tertiary text-sds-brand-default",
  queued: "bg-sds-attention-tertiary text-sds-attention-default",
  failed: "bg-sds-urgent-tertiary text-sds-urgent-default",
  muted: "bg-sds-base-secondary text-sds-base-secondary"
};

/** Solid dot colour classes for a status pill, keyed by pill variant. */
export var SMS_DOT_CLASSES = {
  viewed: "bg-sds-success-default",
  delivered: "bg-sds-brand-default",
  queued: "bg-sds-attention-default",
  failed: "bg-sds-urgent-default",
  muted: "bg-sds-base-tertiary"
};

/** Status ring tint + icon colour classes, keyed by pill variant. */
export var SMS_RING_CLASSES = {
  viewed: "bg-sds-success-tertiary text-sds-success-default",
  delivered: "bg-sds-brand-tertiary text-sds-brand-default",
  queued: "bg-sds-attention-tertiary text-sds-attention-default",
  failed: "bg-sds-urgent-tertiary text-sds-urgent-default",
  muted: "bg-sds-base-secondary text-sds-base-tertiary"
};